import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-appManagement",
  "use": "icon-appManagement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-appManagement\"><path d=\"M128 324.834l361.239 198.56L489.238 941l-346.03-195.153a29.882 29.882 0 0 1-15.204-25.558l-0.004-0.469V324.834z m779.999-11.312L908 719.82a29.882 29.882 0 0 1-15.208 26.027l-341.434 192.56 0.001-415.578L908 313.522zM503.297 73.86a29.934 29.934 0 0 1 29.406 0L872.1 265.27 519.852 472.002 153.954 270.88z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol